// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"23786482","239":"76f9d85b","455":"3239c8d9"}[chunkId] + ".chunk.js";
};